import { Button, Checkbox, Col, Form, Input, InputPicker, Radio, RadioGroup } from 'rsuite';
import TextField from '../../components/form/textfield';
import { useCallback, useEffect, useRef, useState } from 'react';
import { FlexboxGrid } from 'rsuite';
import Field from '../../components/form/field';
import TextAreaField from '../../components/form/textarea-field';

import { faIR } from 'date-fns-jalali/locale';
import { format } from 'date-fns-jalali';
import { DatePicker } from '../../components/form/datepicker/datepicker';
import { handlePostConsultantPersonal, handleGetConsultantPersonal } from '../../api-handler';
import { showToast } from '../../utils/toast';
import { ConsultantPersonalFormSchema } from '../../models';
import { useNavigate } from 'react-router-dom';
import { CustomLoader } from '../../components/basic/loader';

export const ConsultantPersonal = (props: {
  disabledMode?: boolean;
  isAdmin?: boolean;
  username?: string;
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [editMode, setEditMode] = useState(false);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const formRef = useRef<any>(null);
  const [formError, setFormError] = useState({});
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [formValue, setFormValue] = useState<any>({});

  const [sex, setSex] = useState('آقا');
  const [hasCompany, setHasCompany] = useState(false);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [timeStamp, setTimeStamp] = useState<any>(new Date());
  const [calendarOpen, setCalendarOpen] = useState(false);

  const handleSubmit = useCallback(async () => {
    if (formRef.current && !formRef.current.check()) {
      console.log('formError', formError);
      return;
    }

    if (!formValue) return;
    let payload = {
      ...formValue,
      HasCompany: hasCompany,
      Sex: sex === 'آقا',
      CellPhone: `+98${formValue.CellPhone.substring(1)}`,
      Birth_Date: timeStamp,
      CountryB: 'ایران'
    };
    if (payload.CompanyPhone) {
      payload = { ...payload, CompanyPhone: `+98${payload.CompanyPhone.substring(1)}` };
    }

    if (!payload.HasCompany) {
      delete payload.Role;
      delete payload.CompanyName;
      delete payload.CompanyID;
      delete payload.CompanyEmail;
      delete payload.CompanyType;
      delete payload.CompanySite;
      delete payload.CompanyPhone;
      delete payload.CompanyAddress;
      delete payload.CompanyField;
    } else {
      let hadError = false;
      for (const item of [
        'Role',
        'CompanyName',
        'CompanyID',
        // 'CompanyEmail',
        'CompanyType',
        // 'CompanySite',
        'CompanyAddress',
        'CompanyField'
      ]) {
        if (!payload[item]) {
          hadError = true;
          setFormError((prev) => {
            return { ...prev, [item]: 'الزامی است!' };
          });
        }
      }
      if (hadError) return;
    }
    if (!payload.Sex) {
      delete payload.MilitaryService;
    }
    setLoading(true);
    if (editMode) {
      // showToast('اطلاعات قبلا ثبت شده', 'warning');
      setLoading(false);
      navigate('/consultant/work');
      return;
    }
    const res = await handlePostConsultantPersonal(payload);
    if (res.ok) {
      showToast('مشخصات فردی ثبت شد!', 'success');
      navigate('/consultant/work');
      setLoading(false);
      return;
      // todo: navigate to next step
    }
    setLoading(false);
  }, [formValue, formError, timeStamp, sex, formRef, hasCompany]);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const res = await handleGetConsultantPersonal(props.isAdmin ? props.username : null);
      if (res.ok) {
        setFormValue(res.data);
        if (res.data.HasCompany) {
          setHasCompany(true);
        }
        setSex(res.data.Sex ? 'آقا' : 'خانم');
        setTimeStamp(res.data.Birth_Date);
        setEditMode(true);
      }
      setLoading(false);
    })();
  }, [props.username]);

  if (loading) {
    return <CustomLoader />;
  }
  return (
    <>
      <h4 className="text-h4">{props.isAdmin ? 'مشخصات فردی' : 'مشخصات فردی خود را وارد کنید'}</h4>

      <Form
        ref={formRef}
        onChange={setFormValue}
        onCheck={setFormError}
        formError={formError}
        formValue={formValue}
        model={ConsultantPersonalFormSchema}
        onSubmit={handleSubmit}
        checkTrigger="change"
        className="mt-6 text-dark"
        readOnly={loading}
        disabled={props.disabledMode}>
        <FlexboxGrid>
          <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
            <TextField
              name="FirstName"
              label="نام"
              type="text"
              accepter={Input}
              full
              dir="rtl"
              placeholder=""
              req
            />
          </FlexboxGrid.Item>
          <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
            <TextField
              name="LastName"
              label="نام خانوادگی"
              type="text"
              accepter={Input}
              dir="rtl"
              full
              placeholder=""
              req
            />
          </FlexboxGrid.Item>
          <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
            <TextField
              name="NID"
              label="کد ملی"
              type="number"
              accepter={Input}
              dir="ltr"
              full
              placeholder=""
              req
            />
          </FlexboxGrid.Item>
          <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
            <Field
              name="Sex"
              label="جنسیت"
              accepter={RadioGroup}
              value={sex}
              onChange={(value: string) => setSex(value)}>
              <div className="flex">
                <Radio className="w-[50%]" value={'خانم'}>
                  خانم
                </Radio>
                <Radio className="w-[50%]" value={'آقا'}>
                  آقا
                </Radio>
              </div>
            </Field>
          </FlexboxGrid.Item>
          <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
            <Field
              name="MilitaryService"
              label="وضعیت خدمت"
              accepter={InputPicker}
              data={[{ label: 'وضعیت 1', value: 'وضعیت 1' }]}
              dir="rtl"
              full
              req
              disabled={sex !== 'آقا' || props.disabledMode}
            />
          </FlexboxGrid.Item>
          <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
            <TextField
              name="FathersName"
              label="نام پدر"
              type="text"
              accepter={Input}
              dir="rtl"
              full
              req
              placeholder=""
            />
          </FlexboxGrid.Item>
          <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
            <TextField
              name="Email"
              label="ایمیل"
              type="email"
              accepter={Input}
              dir="ltr"
              full
              placeholder=""
              req
            />
          </FlexboxGrid.Item>
          <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={16} className="max-w-[100%] !px-0">
            <FlexboxGrid>
              <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
                <Field
                  name="CountryB"
                  label="کشور محل تولد"
                  accepter={InputPicker}
                  data={[{ label: 'ایران', value: 'ایران' }]}
                  dir="rtl"
                  full
                  defaultValue="ایران"
                  disabled
                  req
                />
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
                <Field
                  name="StateB"
                  label="استان محل تولد"
                  accepter={InputPicker}
                  data={[{ label: 'استان 1', value: 'استان 1' }]}
                  dir="rtl"
                  full
                  req
                />
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
                <Field
                  name="CityB"
                  label="شهر محل تولد"
                  accepter={InputPicker}
                  data={[{ label: 'شهر 1', value: 'شهر 1' }]}
                  dir="rtl"
                  full
                  req
                />
              </FlexboxGrid.Item>
            </FlexboxGrid>
          </FlexboxGrid.Item>

          <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
            <TextField
              name="CellPhone"
              label="شماره تلفن همراه"
              type="number"
              accepter={Input}
              dir="ltr"
              full
              placeholder="09123456789"
              req
            />
          </FlexboxGrid.Item>
          <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
            <TextField
              name="Website"
              label="سایت شخصی"
              type="text"
              accepter={Input}
              dir="ltr"
              full
              placeholder=""
            />
          </FlexboxGrid.Item>
          <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
            <div style={{ position: 'relative' }}>
              <TextField
                className="font-fd cursor-pointer mb-4"
                name="Birth_Date"
                type="text"
                dir="rtl"
                full
                accepter={Input}
                readOnly
                value={format(timeStamp, 'dd MMMM yyyy', { locale: faIR })}
                label="تاریخ"
                req
                onClick={() => setCalendarOpen((state) => !state)}
              />
              <div
                style={{
                  position: 'absolute',
                  top: 60,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  zIndex: 1000
                }}>
                <DatePicker
                  defaultDate={timeStamp}
                  onSelectDate={setTimeStamp}
                  open={calendarOpen}
                  setOpen={setCalendarOpen}
                  hideTime
                  hideToday
                  hideConfirm
                />
              </div>
            </div>
          </FlexboxGrid.Item>
          <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
            <Field
              accepter={InputPicker}
              data={[{ label: 'مدرک 1', value: 'مدرک 1' }]}
              name="EduDegree"
              label="آخرین مدرک تحصیلی"
              dir="rtl"
              full
              req
            />
          </FlexboxGrid.Item>
          <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
            <TextField
              name="RID"
              label="شماره شناسنامه"
              type="text"
              accepter={Input}
              dir="ltr"
              full
              placeholder=""
              req
            />
          </FlexboxGrid.Item>

          <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={24} className="max-w-[100%]">
            <Field
              name="HasCompany"
              onChange={(value: string | number, checked: boolean) => {
                setHasCompany(checked);
              }}
              label=""
              checked={hasCompany}
              accepter={Checkbox}
              dir="rtl"
              full>
              دارای شرکت ثبت شده به این نام؟ یا عضو هیئت مدیره؟
            </Field>
          </FlexboxGrid.Item>
          {hasCompany ? (
            <>
              <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
                <Field
                  name="Role"
                  label="سمت در شرکت"
                  accepter={InputPicker}
                  data={[{ label: 'سمت 1', value: 'سمت 1' }]}
                  dir="rtl"
                  full
                  req
                />
              </FlexboxGrid.Item>

              <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
                <TextField
                  name="CompanyName"
                  label="نام شرکت"
                  type="text"
                  accepter={Input}
                  dir="rtl"
                  full
                  req
                  placeholder=""
                />
              </FlexboxGrid.Item>

              <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
                <TextField
                  name="CompanyID"
                  label="شناسه ثبت شرکت"
                  type="text"
                  accepter={Input}
                  dir="ltr"
                  full
                  req
                  placeholder=""
                />
              </FlexboxGrid.Item>

              <FlexboxGrid.Item
                as={Col}
                colspan={24}
                sm={24}
                md={16}
                className="max-w-[100%] !px-0">
                <FlexboxGrid>
                  <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={12} className="max-w-[100%]">
                    <TextField
                      name="CompanyPhone"
                      label="شماره تماس شرکت"
                      type="number"
                      accepter={Input}
                      dir="ltr"
                      full
                      req
                      placeholder=""
                    />
                  </FlexboxGrid.Item>

                  <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={12} className="max-w-[100%]">
                    <TextField
                      name="CompanyEmail"
                      label="پست الکترونیکی شرکت"
                      type="email"
                      accepter={Input}
                      dir="ltr"
                      full
                      placeholder=""
                    />
                  </FlexboxGrid.Item>

                  <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={12} className="max-w-[100%]">
                    <Field
                      name="CompanyType"
                      label="نوع شرکت"
                      accepter={InputPicker}
                      data={[{ label: 'نوع 1', value: 'نوع 1' }]}
                      dir="rtl"
                      full
                      req
                    />
                  </FlexboxGrid.Item>

                  <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={12} className="max-w-[100%]">
                    <TextField
                      name="CompanySite"
                      label="سایت شرکت"
                      type="text"
                      accepter={Input}
                      dir="ltr"
                      full
                      placeholder=""
                    />
                  </FlexboxGrid.Item>
                </FlexboxGrid>
              </FlexboxGrid.Item>

              <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
                <TextAreaField
                  name="CompanyAddress"
                  label="آدرس شرکت"
                  dir="rtl"
                  full
                  req
                  placeholder=""
                />
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
                <TextField
                  name="CompanyField"
                  label="محصول / حوزه فعالیت شرکت"
                  type="text"
                  accepter={Input}
                  dir="rtl"
                  full
                  req
                  placeholder=""
                />
              </FlexboxGrid.Item>
            </>
          ) : null}
        </FlexboxGrid>
        {!props.disabledMode ? (
          <div className="flex justify-between">
            <Button appearance="primary" className="mr-auto mt-8" type="submit" loading={loading}>
              مرحله بعد
            </Button>
          </div>
        ) : null}
      </Form>
    </>
  );
};
